import { render, staticRenderFns } from "./MeasurementsUpdatesTable.vue?vue&type=template&id=089b1084&scoped=true&"
import script from "./MeasurementsUpdatesTable.vue?vue&type=script&lang=js&"
export * from "./MeasurementsUpdatesTable.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementsUpdatesTable.vue?vue&type=style&index=0&id=089b1084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b1084",
  null
  
)

/* custom blocks */
import block0 from "./MeasurementsUpdatesTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports